import request from 'lib/request';

export interface Response {
  code: number;
  msg: string;
  data: null;
}

export async function trackProject(id: number) {
  const res = await request<Response>('/project/track', {
    method: 'POST',
    data: {
      id,
    },
  });
  return res;
}

